module.exports = __webpack_public_path__ + "img/setting.8ce78e19.svg";